import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function WishlistHeart({ alias, size = 18, className = '' }) {
  const { token } = useAuth();
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token || !alias) return;
    // Check on mount (use cached set)
    const cached = window.__wishlistSet;
    if (cached) {
      setActive(cached.has(alias));
      return;
    }
    fetch(`${API}/api/auth/me/wishlist`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => {
        const set = new Set((d.aliases || []).map(String));
        window.__wishlistSet = set;
        setActive(set.has(alias));
      }).catch(() => {});
  }, [token, alias]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!token) {
      // Not logged in — redirect to auth
      window.location.href = '/auth?redirect=' + encodeURIComponent(window.location.pathname);
      return;
    }
    setLoading(true);
    const method = active ? 'DELETE' : 'POST';
    try {
      await fetch(`${API}/api/auth/me/wishlist/${alias}`, {
        method,
        headers: { Authorization: `Bearer ${token}` }
      });
      setActive(!active);
      if (window.__wishlistSet) {
        active ? window.__wishlistSet.delete(alias) : window.__wishlistSet.add(alias);
      }
    } catch {}
    setLoading(false);
  };

  return (
    <button
      onClick={toggle}
      disabled={loading}
      className={`wishlist-heart ${active ? 'active' : ''} ${className}`}
      data-testid={`wishlist-heart-${alias}`}
      title={active ? 'Von Wunschliste entfernen' : 'Zur Wunschliste'}
      style={{
        background: 'rgba(0,0,0,0.5)',
        border: 'none',
        cursor: 'pointer',
        padding: 6,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Heart
        size={size}
        fill={active ? 'var(--primary, #ff2e2e)' : 'none'}
        color={active ? 'var(--primary, #ff2e2e)' : 'rgba(255,255,255,0.7)'}
        strokeWidth={active ? 0 : 2}
      />
    </button>
  );
}
